import { ref } from 'vue';
import { groupCollectionsClient } from '~/services';
import { createGlobalState } from '@vueuse/core';
import type { ClientContext } from '~/services/contextClient';

export const useGroupCollectionsGroupsCount = createGlobalState(() => {
    // [groupCollectionId]: groupsCount
    // undefined = loading
    // null = not found
    const groupCounts = ref<Record<number, number>>({});

    const fetching = ref(false);

    const fetchGroupCollectionsGroupsCount = async (
        context: Omit<ClientContext, 'groupId'>,
        groupCollectionIds: number[]
    ) => {
        // remove existing ids to avoid computing them again
        groupCollectionIds = groupCollectionIds.filter((groupCollectionId) => !groupCounts.value[groupCollectionId]);

        if (!groupCollectionIds.length) {
            return;
        }

        if (fetching.value) {
            // when its currently making a request call wait a bit before retrieving again
            setTimeout(() => {
                fetchGroupCollectionsGroupsCount(context, groupCollectionIds);
            }, 500);
            return;
        }

        try {
            fetching.value = true;

            const response = await groupCollectionsClient.getGroupCollectionsGroupCounts(context, {
                group_collection_ids: groupCollectionIds,
            });

            groupCollectionIds.forEach((groupCollectionId) => {
                groupCounts.value[groupCollectionId] = response.data.counts[groupCollectionId] ?? 0;
            });
        } finally {
            fetching.value = false;
        }
    };

    return {
        fetchGroupCollectionsGroupsCount,
        groupCounts,
    };
});
